<div [class]="'tab-container ' + tabOrientation" [class.collapsed]="menuCollapsed">
  <ul ngbNav [orientation]="tabOrientation" #ngbNavReference="ngbNav" [class]="'nav-tabs ' + tabOrientation" [activeId]="activeTabId()"
      (navChange)="onNavChange($event)" [destroyOnHide]="destroyOnHide">
    <ng-container *ngFor="let tabNavItem of tabNavItems">
      <li [ngbNavItem]="tabNavItem.id" [destroyOnHide]="tabNavItem.destroyOnHide" [disabled]="tabNavItem.disabled">
        <a ngbNavLink draggable="false">
          <div class="d-flex">
            <div class="title-icon" *ngIf="tabNavItem.icon">
              <qpoint-icon [icon]="tabNavItem.icon"></qpoint-icon>
            </div>
            <div *ngIf="!menuCollapsed && !tabNavItem.editMode()" class="title-text" (dblclick)="onTabNameDoubleClick(tabNavItem)">{{ tabNavItem.label }}</div>
            <div class="title-text" *ngIf="tabNavItem.editMode()">
              <input kendoTextBox #tabNameInput type="text" class="form-control"
                     (input)="tabNavItem.validateTabName(tabNameInput.value, anchor)"
                     [class.is-invalid]="tabNavItemInvalid() || tabNavItem.errors()?.length > 0" required
                     [value]="tabNavItem.label"
                     (click)="$event.preventDefault();$event.stopPropagation()" kendoPopoverAnchor
                     [popover]="errorPopover" showOn="none"
                     (keyup.enter)="!tabNavItemInvalid() && tabNavItem.handleTabNameChange(tabNameInput.value)"
                     #anchor="kendoPopoverAnchor"
                     (keyup.escape)="tabNavItem.cancel()"/>

              <kendo-popover #errorPopover [position]="errorPopupPosition" [offset]="24">
                <ng-template kendoPopoverBodyTemplate>
                  <div class="validation-container" *ngIf="tabNavItem.errors() as errors">
                    <div *ngFor="let error of errors">
                      <qpoint-icon icon="exclamation-circle"></qpoint-icon>
                      <span>{{ error }}</span>
                    </div>
                  </div>
                </ng-template>
              </kendo-popover>

            </div>

            <ng-container *ngIf="tabNavItem.showMenu()">
              <kendo-dropdownbutton class="menu-button" [data]="tabNavItem.menuItems()" size="small" fillMode="flat"
                                    (click)="$event.preventDefault(); $event.stopImmediatePropagation()"
                                    (itemClick)="handleTabNavMenuItemClick(tabNavItem, $event)" buttonClass="p-0"
                                    [svgIcon]="moreVerticalIcon">
                <ng-template kendoDropDownButtonItemTemplate let-dataItem>
                  <span>{{ dataItem.label }}</span>
                </ng-template>
              </kendo-dropdownbutton>
            </ng-container>
          </div>
        </a>
        <ng-template ngbNavContent>
          <ng-template *ngTemplateOutlet="tabNavItem.detailTemplate || null"></ng-template>
        </ng-template>
      </li>
    </ng-container>
    <li *ngIf="canAddTab" class="nav-item">
      <qpoint-button class="nav-link add-button" (click)="addTabClick.emit()">
        <qpoint-icon icon="plus-circle" iconType="regular"></qpoint-icon>
      </qpoint-button>
    </li>
  </ul>
  <div [ngbNavOutlet]="ngbNavReference" class="mt-2 occupyAvailableSpace"></div>
</div>
